<!--
 * @Author: 孙照
 * @LastEditTime: 2023-11-24 17:03:56
 * @Description: 公交线路组件
 * @FilePath: \sheyang\src\module\overview\stationChargeModal\components\busLines.vue
-->
<template>
  <div class="bus-lines">
    <pub-info-title :title="'实时监控'" :is-modal-long="true" />
    <div class="monitor-container">

    </div>
    <!-- <div class="lines-container">
      <div class="table-title">
        <div class="title-item">车号</div>
        <div class="title-item">公司</div>
        <div class="title-item">分公司</div>
        <div class="title-item">车队</div>
        <div class="title-item">线路</div>
      </div>
      <vue-seamless-scroll
        :data="busLine"
        :class-option="classOption"
        class="warp"
        >
        <ul class="list">
          <li class="list-item" v-for="(item, index) in busLine" :key="index">
            <span class="value" v-text="item.plateNo"></span>
            <span class="value" v-text="item.companyName"></span>
            <span class="value" v-text="item.subCompanyName"></span>
            <span class="value" v-text="item.fleetName"></span>
            <span class="value" v-text="item.busName"></span>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div> -->
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import { getStationDetail } from '@/api/overView';
import { mapGetters } from 'vuex';

export default {
  name: 'busLines',
  components: {
    pubInfoTitle,
  },
  data() {
    return {
      busLine: [],
      classOption: {
        step: 0.5,
      },
    };
  },
  computed: {
    ...mapGetters({
      stationId: 'stationId',
    }),
  },
  // watch: {
  //   stationId: {
  //     handler(val) {
  //       this.getBusLine({ stubGroupId: val });
  //     },
  //     immediate: true,
  //   },
  // },
  methods: {
    getBusLine(params) {
      getStationDetail(params).then((res) => {
        // console.log('---公交线路', res, '---');
        if (res.code === '200') {
          const { busRoadMapListList } = res.data;
          // console.log('--公交线路', busRoadMapListList, '---');
          this.busLine = [...busRoadMapListList];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bus-lines {
  margin-top: 20px;
  ::v-deep .pub-info-title {
    margin-bottom: 16px;
  }

  .monitor-container {
    width: 764px;
    height: 354px;
    background: #000;
  }
  .lines-container {
    width: 764px;
    height: 368px;
    // .backgroundImage('@/assets/images/busLineBg.png');
    margin-top: 20px;
    .table-title {
      width: 100%;
      height: 42px;
      box-sizing: border-box;
      padding-right: 33px;
      margin-bottom: 10px;
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      background: rgba(143,204,255,0.09);
      box-shadow: inset 0px 0px 11px 0px rgba(79,179,255,0.54);
      border: 1px solid;
      border-image: linear-gradient(140deg, rgba(136, 230, 255, 1), rgba(143, 204, 255, 1)) 1 1;
      .title-item {
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #C6E8FF;
      }
    }
    .warp {
      width: 764px;
      height: 302px;
      margin: 0 auto;
      overflow: hidden;
      ul {
        width: 100%;
        list-style: none;
        padding: 0;
        margin: 0 auto;
      }
      li {
        list-style-type: none;
      }
      .list{
        .list-item {
          width: 100%;
          height: 42px;
          position: relative;
          box-sizing: border-box;
          padding-right: 33px;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          margin-bottom: 5px;
          background: rgba(10, 50, 89, 0.6);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F5F5F5;
          .value {
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            height: 42px;
            line-height: 42px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #E7F5FF;
          }
          // .icon {
          //   position: absolute;
          //   top: 50%;
          //   right: 20px;
          //   transform: translateY(-50%);
          //   cursor: pointer;
          //   .glass {
          //     width: 12px;
          //     height: 12px;
          //   }
          // }
        }
      }
    }
  }

}
</style>
